import { DEFAULT_COLOR_TRADE_AREA_PALETTE_COLORS as e } from "./index.es59.js";
import "@turf/turf";
import "./index.es175.js";
import { rgbArrayToHex as t } from "./index.es277.js";
import "./index.es176.js";
const l = {
  visualizationType: "choropleth",
  boundaryType: "polygon",
  numberOfVisitsSelected: [30],
  polygonMiRadius: 50,
  // DotDensityFilters
  minVisits: 1,
  visitorsOrigin: "home",
  metric: "visits"
}, u = {
  opacity: 30,
  palette: e[0],
  stroke: 3,
  inEditMode: !0,
  includeLayer: !0,
  legendTitle: "True Trade Area",
  dotRadius: 2,
  dotOpacity: 100,
  dotDensityLegendTitle: "Visits",
  items: [
    {
      color: t(e[0].paletteColors[0]),
      value: "30",
      visible: !0
    }
  ]
};
export {
  l as trueTradeAreaDefaultFetchFilter,
  u as trueTradeAreaDefaultVisualFilter
};
//# sourceMappingURL=index.es78.js.map
